import axios from '../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSitesByCampaignId = createAsyncThunk(
  'settings/getSites',
  async (campaignId) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/campaign/getSites/${campaignId}`,
      { campaignId: campaignId }
    )
);
export const insertSite = createAsyncThunk(
  'settings/insertSite',
  async (data) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/campaign/insertSite`,
      data
    )
);

export const updateSite = createAsyncThunk(
  'settings/updateSite',
  async (data) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/campaign/updateSite`,
      data
    )
);
export const deleteSite = createAsyncThunk(
  'settings/deleteSite',
  async (siteId) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/campaign/deleteSite/${siteId}`,
      { siteId: siteId }
    )
);

export const fetchShortcutsByCampaignId = createAsyncThunk(
  'settings/getShortKeys',
  async (campaignId) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/campaign/getShortKeys/${campaignId}`
    )
);
export const insertShortCut = createAsyncThunk(
  'settings/insertShortcut',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/campaign/insertShortKey`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.ShortKey)
          return rejectWithValue({
            Errors: err.response.data.errors.ShortKey,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateShortcut = createAsyncThunk(
  'settings/updateShortcut',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/campaign/updateShortKey`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.ShortKey)
          return rejectWithValue({
            Errors: err.response.data.errors.ShortKey,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteShortcut = createAsyncThunk(
  'settings/deleteShortcut',
  async (data) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/campaign/removeShortKey`,
      data
    )
);

export const getAllCampaigns = createAsyncThunk(
  'campaign/getCampaigns',
  async (accountId) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/Campaign/getCampaigns/${accountId}`
    )
);

export const getUserCampaignsByEmail = createAsyncThunk(
  'user/getUserCampaignsByEmail',
  async (email) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/User/getUserCampaignsByEmail/${email}`
    )
);

export const createCampaign = createAsyncThunk(
  'campaign/insert',
  async ({ data, userId }, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/Campaign/insertCampaign/${userId}`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Campaign)
          return rejectWithValue({
            Errors: err.response.data.errors.Campaign,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateCampaign = createAsyncThunk(
  'campaign/update',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/Campaign/updateCampaign`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Campaign)
          return rejectWithValue({
            Errors: err.response.data.errors.Campaign,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteCampaign = createAsyncThunk(
  'campaign/delete',
  async (campaignId, { rejectWithValue }) => {
    try {
      return await axios.delete(
        `${process.env.REACT_APP_APIURL}/Campaign/deleteCampaign/${campaignId}`
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Campaign)
          return rejectWithValue({
            Errors: err.response.data.errors.Campaign,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchDispositionsByCampaignId = createAsyncThunk(
  'settings/getDispositions',
  async (campaignId) =>
    await axios.get(
      `${process.env.REACT_APP_APIURL}/Campaign/getDispositions/${campaignId}`
    )
);

export const updateDisposition = createAsyncThunk(
  'settings/updateDisposition',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/Campaign/updateDisposition`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Disposition)
          return rejectWithValue({
            Errors: err.response.data.errors.Disposition,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const createDisposition = createAsyncThunk(
  'settings/createDisposition',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/Campaign/createDisposition`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Disposition)
          return rejectWithValue({
            Errors: err.response.data.errors.Disposition,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDisposition = createAsyncThunk(
  'settings/deleteDisposition',
  async (data, { rejectWithValue }) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_APIURL}/Campaign/deleteDisposition`,
        data
      );
    } catch (err) {
      if (err.response.data.errors) {
        if (err.response.data.errors.Disposition)
          return rejectWithValue({
            Errors: err.response.data.errors.Disposition,
          });
      }
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCampaignById = (campaignId) => {
  return axios.get(
    `${process.env.REACT_APP_APIURL}/Campaign/getCampaignById/${campaignId}`
  ).then(res => res.data).catch(err => {
    if (!err.response) {
      return ({
        Errors: 'Network Error'
      });
    }
    if (err.response.data.errors) {
      if (err.response.data.errors.Campaign)
        return ({
          Errors: err.response.data.errors.Campaign,
        });
    }
    return ({
      Errors: err.response.data,
    });
  })
};

export const createChatUser = (data) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/user/addUser`, data)
    .then(res => res.data).catch(err => {
      if (!err.response) {
        return ({
          Errors: 'Network Error'
        });
      }
      if (err.response.data.errors) {
        if (err.response.data.errors.User)
          return ({
            Errors: err.response.data.errors.User,
          });
      }
      return ({
        Errors: err.response.data,
      });
    })
};

export const campaignSetup = (data) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/campaign/setup`, data)
    .then(res => res.data).catch(err => {
      if (!err.response) {
        return ({
          Errors: 'Network Error'
        });
      }
      if (err.response.data.errors) {
        if (err.response.data.errors.Campaign)
          return ({
            Errors: err.response.data.errors.Campaign,
          });
      }
      return ({
        Errors: err.response.data,
      });
    })
};
